import UserAvatar from './user-avatar';

import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import AddToDrive from '@mui/icons-material/AddToDrive';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Code from '@mui/icons-material/Code';
import Domain from '@mui/icons-material/Domain';
import Folder from '@mui/icons-material/Folder';
import Group from '@mui/icons-material/Group';
import MiscellaneousServices from '@mui/icons-material/MiscellaneousServices';

interface AvatarChipOldProps {
  email: string;
  type:
    | 'User'
    | 'Group'
    | 'Domain'
    | 'gPanel Role'
    | 'OrgUnit'
    | 'Shared Drive'
    | 'RegEx'
    | 'User Drive'
    | 'Resource Calendar'
    | 'Roles'
    | 'Unknown';
  onDelete?: () => void;
  size?: 'small' | 'medium';
  label?: string;
  tooltip?: string;
  isLoading?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export default function AvatarChipOld({
  email,
  type,
  onDelete,
  size = 'small',
  label,
  tooltip,
  isLoading,
  onClick,
  disabled = false,
}: AvatarChipOldProps) {
  const theme = useTheme();

  if (type === 'Group') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<Avatar children={<Group sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'Domain' || type.includes('Org')) {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<Avatar children={<Domain sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'gPanel Role') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={
            <Avatar children={<AdminPanelSettings sx={{ fontSize: 16 }} />} />
          }
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'Shared Drive') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<Avatar children={<AddToDrive sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'RegEx') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<Avatar children={<Code sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'User Drive') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<Avatar children={<Folder sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'Resource Calendar') {
    return (
      <Tooltip title={tooltip ? tooltip : label ? label : email}>
        <Chip
          key={email}
          label={
            isLoading ? (
              <Skeleton variant="text" width={100} height={20} />
            ) : label ? (
              label
            ) : (
              email
            )
          }
          size={size}
          avatar={<Avatar children={<CalendarMonth sx={{ fontSize: 16 }} />} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'Roles') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={
            <Avatar
              children={<MiscellaneousServices sx={{ fontSize: 16 }} />}
            />
          }
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else if (type === 'Unknown') {
    return (
      <Tooltip title={label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title={tooltip ? tooltip : label ? label : email}>
        <Chip
          key={email}
          label={label ? label : email}
          size={size}
          avatar={<UserAvatar userEmail={email} />}
          onDelete={onDelete ? onDelete : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          clickable={onClick ? true : false}
          sx={{
            width: 'fit-content',
            backgroundColor: onClick
              ? theme.palette.primary.light
              : '-moz-initial',
            ':hover': {
              backgroundColor: (theme) =>
                onClick ? theme.palette.primary.main : '-moz-initial',
            },
          }}
          disabled={disabled}
        />
      </Tooltip>
    );
  }
}
